import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';

import { Funnel, ProductResponse, ResponseDetails } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';
import { Institute } from '@/features/institute/types/indes';
import { Contact } from '@/features/contact/types/indes';




export type DTO1 = {
    name: string,
    stateId?: any,
    cityId?: any
  };

  export type ResponseInstitute = {
    name: string,
  };
  
  
  export const getEmailDetails = (
    {  name, stateId, cityId}: DTO1 
  ): Promise<any> => {
    return axios.get(`/superadmin/get-institute-details/${name}/${stateId}/${cityId}`, {
    });
  };
  
  
  type UseOptions = {
  config?: MutationConfig<typeof getEmailDetails>;
  };
  
  export const useGetInstituteDetails= ({ config }: UseOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getEmailDetails,
  });
  };
  
  

export type DTO11 = {
    phone: string,
    instituteName?: any;
    stateId?: any;
    cityId?: any
  };

  export const getPhoneDetails = (
    {  phone, instituteName, stateId, cityId}: DTO11 
  ): Promise<Contact> => {
    return axios.post(`/superadmin/get-contact-details/${phone}`, {
      instituteName, stateId,cityId
    });
  };
  
  
  type UseOptions2 = {
  config?: MutationConfig<typeof getPhoneDetails>;
  };
  
  export const useGetPhoneDetails= ({ config }: UseOptions2 = {}) => {
  return useMutation({
    ...config,
    mutationFn: getPhoneDetails,
  });
  };
  
  